import React, { useMemo } from 'react';
import { AssessmentDifferential } from 'js/components/Charts/AssessmentDifferential';
import { transformActivityToAssessments } from './transformActivityToAssessments';

const FooterComponent = () => {
  return (
    <div className="small" style={{ opacity: 0.8 }}>
      (For rubrics, scores are sourced from the latest results available for
      each question/set.)
    </div>
  );
};

/**
 * Facade over AssessmentDifferential for team rubric scores: converts rubric activity
 * (evaluation shape + per-instance triple maps) into pseudo-assessments.
 */
function RubricAssessmentDifferential({
  questionSets = [],
  assessmentInstances = [],
  assessmentScoreMaps = {},
  carryScoresForward = true,
}) {
  const assessments = useMemo(
    () =>
      transformActivityToAssessments(
        questionSets,
        assessmentInstances,
        assessmentScoreMaps,
        carryScoresForward
      ),
    [questionSets, assessmentInstances, assessmentScoreMaps, carryScoresForward]
  );

  return (
    <>
      <AssessmentDifferential
        assessments={assessments}
        showStale={true}
        footerComponent={FooterComponent}
      />
    </>
  );
}

export default RubricAssessmentDifferential;
